module.exports = __webpack_public_path__ + "img/circle_brown.c31b4ed2.png";